import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Completed: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[1.6px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9998 22.6999C6.09739 22.6999 1.2998 17.9024 1.2998 12C1.2998 6.09761 6.09739 1.30005 11.9998 1.30005C17.9022 1.30005 22.6998 6.09761 22.6998 12C22.6998 17.9024 17.9022 22.6999 11.9998 22.6999ZM11.9998 2.79307C6.92353 2.79307 2.79283 6.92374 2.79283 12C2.79283 17.0763 6.92353 21.2069 11.9998 21.2069C17.0761 21.2069 21.2068 17.0763 21.2068 12C21.2068 6.92374 17.0761 2.79307 11.9998 2.79307Z"
      fill="currentColor"
      strokeWidth="currentStrokWidth"
    />
    <path
      d="M10.5858 15.5634C10.3867 15.5634 10.1976 15.4838 10.0583 15.3445L7.24139 12.5276C6.95274 12.239 6.95274 11.7612 7.24139 11.4726C7.53004 11.1839 8.00781 11.1839 8.29646 11.4726L10.5858 13.7619L15.7019 8.64579C15.9906 8.35714 16.4683 8.35714 16.757 8.64579C17.0456 8.93444 17.0456 9.41221 16.757 9.70086L11.1133 15.3445C10.974 15.4838 10.7849 15.5634 10.5858 15.5634Z"
      fill="currentColor"
      strokeWidth="currentStrokWidth"
    />
  </svg>
);

export default Completed;
